import React from 'react';
import {BaseMixin, ContentMixin} from './../../common/common.js';

import {Div} from '../../bricks/bricks.js';
import './message.less';

export default React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ContentMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: "UU5.Forms.Message",
    classNames: {
      main: "uu5-forms-message"
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    feedback: React.PropTypes.string
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps: function () {
    return {
      feedback: null
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  shouldComponentUpdate(newProps, newState){
    let result = false;
    if (newProps.content != this.props.content || newProps.feedback != this.props.feedback) {
      result = true;
    }
    return result;
  },
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _getMainPropsToPass(){
    let mainAttrs = this.getMainPropsToPass();
        mainAttrs.className += ' uu5-common-bg';
    return mainAttrs;
  },
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    return (
      //UU5.Bricks.Div is important for render content like html tags
      <Div {...this._getMainPropsToPass()}>
        {this.getChildren()}
      </Div>
    );
  }
  //@@viewOn:render
});


// WEBPACK FOOTER //
// ./forms/internal/message.js